









import { Component, Mixins } from "vue-property-decorator";
import { NotImplementedItem } from "../../../../domain/document/items";
import {
  ForegroundDrawableObjectMixin,
} from "./mixins";

@Component({
})
export default class NotImplementedObject extends Mixins(
  ForegroundDrawableObjectMixin,
) {
  editingSource: NotImplementedItem;

  get overview(): string {
    return "未実装(" + this.editingSource.trueTypeKey + ")";
  }
}
